import Header from "@/components/Header/Header.vue"

export default {
    name: 'Pay',
    components: {
        Header,
    },
}
